import type { ReactNode } from 'react'

export function LoadingNote({ children }: { children: ReactNode }) {
  return <p style={{ fontFamily: 'var(--font-body)', color: 'var(--color-text-secondary)' }}>{children}</p>
}

export function ErrorNote({ children }: { children: ReactNode }) {
  return <p style={{ fontFamily: 'var(--font-body)', color: 'var(--color-error-text)' }}>{children}</p>
}

export function EmptyNote({ children }: { children: ReactNode }) {
  return <p style={{ fontFamily: 'var(--font-body)', color: 'var(--color-text-secondary)' }}>{children}</p>
}
